import { IManutencaoConcluida } from "../../../Interfaces/AssistenciaTecnica/ManutencaoConcluida/ManutencaoConcluidaInterface";
import { ManutencaoConcluidaService } from "../../../Services/AssistenciaTecnica/ManutencaoConcluida/ManutencaoConcluidaServices";
import { Controller } from "../../Controller";

export async function ManutencaoConcluidaController(
    data: IManutencaoConcluida
) {
    return Controller(ManutencaoConcluidaService(data));
}
